<template>
  <div style="max-width: 700px;" v-if="!success">
    <v-form v-model="valid">
      <v-card class="mb-4">
        <v-card-text>
          <v-autocomplete filled return-object :items="branches" item-text="BranchAddress" v-model="branch"
                          @change="onBranchSelect()"
                          label="Επιλέξτε Κτήριο" :rules="rules.branchRule">
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title> {{ data.item.BranchAddress }}, {{ data.item.BranchDimosName }}
                </v-list-item-title>
                <v-list-item-subtitle> {{ data.item.PartnerBrandName }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-autocomplete filled return-object v-if="branch" :items="branch.Projects" @change="onProjectSelect()"
                          item-text="ProjectName" v-model="project" :label="'Επιλέξτε '+$unitText('Ανυψωτικό')"
                          v-tooltip="'Εάν δεν γνωρίζετε σε ποιό αφορά το αίτημα αφήστε την προεπιλογή'"
                          :rules="rules.projectRule"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title> {{ data.item.ProjectName }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
      </v-card>
      <v-card v-if="partners.length">
        <v-card-text>
          <v-row>
            <v-col>
              <v-autocomplete filled return-object :items="issueTypes" @change="onIssueTypeSelect()"
                              item-text="IssueTitle" v-model="issueType" label="Τύπος Αιτήματος"
                              :rules="rules.issueTypeRule"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title> {{ data.item.IssueTitle }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col v-if="issueType">
              <v-autocomplete filled return-object :items="issueType.Actions" @change="onActionSelect()"
                              item-text="ActionTitle" v-model="action" label="Ενέργεια"
                              :rules="rules.issueActionRule"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title> {{ data.item.ActionTitle }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-textarea filled label="Περιγραφή αιτήματος " v-model="issue.Description" :rules="rules.descriptionRule">
          </v-textarea>
          <v-btn :disabled="!valid" color="primary" @click="newIssue()" large>ΑΠΟΣΤΟΛΗ ΑΙΤΗΜΑΤΟΣ
          </v-btn>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
  <div v-else>
    <v-card>
      <v-card-text class="text-center">
        <v-icon color="green" size="100">mdi-check</v-icon>
        <h2> To αίτημα στάλθηκε στο γραφείο.</h2>
        <v-btn color="secondary" to="/" class="mt-4" dark> Επιστροφή στην αρχική</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "NewIssue",
  data: () => ({
    valid: true,
    issue: {
      Partner_ID: null,
      Contact_ID: null,
      Project_ID: null,
      Description: '',
      Action_ID: '',
      IssueType_ID: null
    },
    rules: {
      branchRule: [
        v => !!v || 'Το κτήριο απαιτείτε',
      ],
      projectRule: [
        v => !!v || 'Δεν επιλέξατε ' + this.$unitText('Ανυψωτικό')
      ],
      issueTypeRule: [
        v => !!v || 'Δεν επιλέξατε τύπο αιτήματος'
      ],
      issueActionRule: [
        v => !!v || 'Δεν επιλέξατε τύπο ενέργειας'
      ],
      descriptionRule: [
        v => !!v || 'Πρέπει να ωρίσετε μια περιγραφή'
      ]
    },
    issueTypes: [],
    issueType: null,
    action: null,
    success: false,
    branch: null,
    project: null
  }),
  created() {
    this.getPartnerDetails()
        .then(r => this.getIssueTypes())
        .then(it => {
          this.issueTypes = it;
          if (this.issueTypes.length === 1) {
            this.issueType = this.issueTypes[0];
            this.action = this.issueType.Actions[0];
            this.issue.IssueType_ID = this.issueType.IssueType_ID;
            this.issue.Action_ID = this.action.Action_ID;
          }
        });
    if (this.branches.length === 1) {
      this.branch = this.branches[0];
      this.onBranchSelect();
    }
    this.issue.Contact_ID = this.userDetails.Contact_ID
  },
  watch: {
    branches: function () {
      if (this.branches.length === 1) {
        this.branch = this.branches[0];
        this.onBranchSelect()
      }
    }
  },
  computed: {
    isAllFilled() {
      let issue = this.issue;
      return !issue.Branch_ID || !issue.Partner_ID || !issue.Project_ID || issue.Description !== '' || !issue.IssueType_ID || !issue.Action_ID;
    },
    ...mapGetters([
      "userDetails",
      "branches",
      "partners"
    ])
  },
  methods: {
    ...mapActions([
      "addIssue",
      "getPartnerDetails",
      "getIssueTypes"
    ]),

    newIssue() {
      this.issue['NextAction_ID'] = this.issue.Action_ID;
      this.addIssue(this.issue).then(
          resp => {
            this.success = true;
          }
      )
    },
    onBranchSelect() {
      this.project = this.branch.Projects[0];
      this.issue.Project_ID = this.branch.Projects[0].Project_ID;
      this.issue.Partner_ID = this.branch.Partner_ID;
      this.issue.Branch_ID = this.branch.Branch_ID;
    },
    onProjectSelect() {
      this.issue.Project_ID = this.project.Project_ID;
    },
    onIssueTypeSelect() {
      this.issue.IssueType_ID = this.issueType.IssueType_ID;
      this.issue.Action_ID = this.issueType.Actions[0].Action_ID;
      this.action = this.issueType.Actions[0];
    },
    onActionSelect() {
      this.issue.Action_ID = this.action.Action_ID
    }
  }
}
</script>

<style scoped>

</style>
